import React, { Component, Fragment } from 'react';
import { Table, Jumbotron, Row, Col, Button, Form } from 'react-bootstrap';
import Menu from '../menu';
import config from '../../config';
import { CSVLink } from "react-csv";

export class ReporteDetallado extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            info: [],
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            empresa: currentCompany
        }
    }

    updateReport = () => {
        const { fecha_inicial, fecha_final, empresa } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                fecha_inicial,
                fecha_final,
                empresa
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }

        fetch(config.servBackEnd + '/reports/detailfe', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const info = data.data;
                    this.setState({ info })
                } else {
                    this.setState({ info: [] })
                }
            })
            .catch((error) => console.error(error))
    }

    render() {
        const { info } = this.state;
        return (
            <Fragment>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">Reporte detallado documentos</Jumbotron>
                <Row>
                    <Col>
                        Fecha Inicial <Form.Control type="date" onChange={(e) => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} />
                    </Col>
                    <Col>
                        Fecha Final <Form.Control type="date" onChange={(e) => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} />
                    </Col>
                    <Col>
                        <Button variant="primary" className="m-3" onClick={this.updateReport} >Genera Informe</Button>
                    </Col>
                    <Col>
                        <CSVLink data={info} filename={"REPORTE_DETALALDO.csv"} separator={";"}>
                            <Button disabled={info.length === 0} variant="success">Descargar Reporte</Button>
                        </CSVLink>
                    </Col>
                </Row>
                <Table className="tableFixHead">
                    <thead>
                        <tr>
                            <th>NIT CLIENTE</th>
                            <th>NOMBRE CLIENTE</th>
                            <th>DOCUMENTO</th>
                            <th>FECHA</th>
                            <th>BRUTO</th>
                            <th>IVA</th>
                            <th>ESTADO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            info.map((element, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{element.DOCUMENTO_CLIENTE}</td>
                                        <td>{element.NOMBRE_CLIENTE}</td>
                                        <td>{element.PREFIJO_DIAN + "-" + element.NUMERO_FACTURA_CABECERA}</td>
                                        <td>{element.FECHA_DOCUMENTO}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.TOTAL_BRUTO)}</td>
                                        <td className="currSign">{Intl.NumberFormat('es-MX').format(element.TOTAL_IVA)}</td>
                                        <td>{element.ESTADO}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
            </Fragment>
        )
    }
}

export default ReporteDetallado
